<template>
   <div class="PortfolioTable-PriceContent">
       <i v-if="symbol.actualNetChange!=0" :class="symbol.actualNetChange > 0 ? 'mr-1 text-success fa fa-arrow-up':'mr-1 text-danger fa fa-arrow-down'"
            v-b-tooltip.hover.html  :title="title" />
        <span>{{ symbol.actualPricePerShare | formatPrice}}</span>
   </div>
</template>
<script>
import {formatPrice} from '@/utils';

import vue from 'vue'

export default vue.extend({
  props: {
    symbol: {
      type: Object,
      required: true,
    },
  },
  computed: {
    title: {
      get() {
        return 'Net Change: ' + formatPrice(this.symbol.actualNetChange);
      },
    },
  },
});
</script>
